import { warn } from '@execonline-inc/logging';
import { BadStatus } from 'ajaxian';
import InviteParticipantStore from '..';
import { handleError } from '../../../../../../../../../../../../ErrorActionableReaction';
import { TPlainTextKey } from '../../../../../../../../../../../../Translations';
import { InviteError } from '../../../../../../../../../Functions';

const badStatusErrorMessage = (error: BadStatus): TPlainTextKey => {
  switch (error.response.body) {
    case 'All participants must belong to the same org when bulk license provisioning':
      return 'All participants must belong to the same org when bulk license provisioning';
    case 'Send email date must be in the future':
      return 'Send email date must be in the future';
    default:
      return 'We are unable to process your request at this time';
  }
};

export const handleInviteError = (store: InviteParticipantStore) => (error: InviteError) => {
  switch (error.kind) {
    case 'bad-status':
      store.error(badStatusErrorMessage(error));
      break;
    case 'missing-link-error':
    case 'invalid-url-error':
      store.error('We are unable to process your request at this time');
      warn('InviteParticipantsReactions', error.kind, error);
      break;
    default:
      handleError(store, error);
  }
};
